(() => {
  const resetKey = 'sh_size_reset';
  const resetUrl = value => {
    const url = new URL(value, location.origin);
    ['variant', 'option_values', 'rl_size'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set(resetKey, '1');
    const theme = new URL(location.href).searchParams.get('preview_theme_id');
    if (theme) url.searchParams.set('preview_theme_id', theme);
    return url;
  };
  const parse = value => {
    try { return JSON.parse(value); } catch { return null; }
  };
  const initialize = () => document.querySelectorAll('product-info.sh-mtc-main').forEach(root => {
    const navigation = root.querySelector('[data-sh-mtc-gender]');
    if (!navigation || navigation.dataset.ready) return;
    navigation.dataset.ready = 'true';
    const links = [...navigation.querySelectorAll('[data-sh-mtc-gender-link]')];
    const pending = new Map();
    let needsSize = new URL(location.href).searchParams.get(resetKey) === '1';
    const colorLinks = () => [...root.querySelectorAll('[data-sh-color-url]')];
    const updateColorReset = () => colorLinks().forEach(link => {
      const url = new URL(link.dataset.shColorUrl, location.origin);
      if (needsSize) url.searchParams.set(resetKey, '1');
      else url.searchParams.delete(resetKey);
      link.dataset.shColorUrl = url.href;
      const target = new URL(link.href, location.origin);
      if (needsSize) {
        target.searchParams.delete('variant');
        target.searchParams.delete('option_values');
        target.searchParams.delete('rl_size');
        target.searchParams.set(resetKey, '1');
      } else target.searchParams.delete(resetKey);
      link.href = target.href;
    });
    const chooseSize = event => {
      if (!needsSize) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const picker = root.querySelector('rl-size-picker');
      if (picker?.classList.contains('rl-size-picker--enhanced')) picker.open(undefined, {center: true});
      else root.querySelector('variant-selects select')?.focus();
    };
    if (needsSize) {
      const url = resetUrl(location.href);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      const select = root.querySelector('variant-selects select');
      if (select) select.selectedIndex = -1;
      root.querySelectorAll('product-form input[name="id"]').forEach(input => { input.value = ''; });
      const button = root.querySelector('.product-form__submit');
      const label = root.querySelector('rl-size-picker')?.dataset.chooseSize || '';
      if (button) {
        const text = button.querySelector('span');
        if (text) text.textContent = label;
        button.disabled = false;
      }
      const picker = root.querySelector('rl-size-picker');
      if (picker?.classList.contains('rl-size-picker--enhanced')) picker.syncSelection();
    }
    updateColorReset();
    const confirmSize = () => {
      if (!needsSize) return;
      needsSize = false;
      const url = new URL(location.href);
      url.searchParams.delete(resetKey);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      updateColorReset();
    };
    root.addEventListener('rl:size-selected', confirmSize, true);
    root.addEventListener('change', event => {
      if (event.target.closest('variant-selects')) confirmSize();
    }, true);
    root.addEventListener('submit', chooseSize, true);
    root.addEventListener('click', event => {
      if (event.target.closest('.product-form__submit')) chooseSize(event);
    }, true);
    const availability = async item => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const response = await fetch(resetUrl(item.url).href, {cache:'no-store', signal:controller.signal});
        if (!response.ok) throw new Error('Product unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const state = parse(page.querySelector('[data-sh-mtc-gender-state]')?.textContent || 'null');
        return state?.product_id === item.product_id && typeof state.available === 'boolean' ? state.available : item.available;
      } catch { return item.available; }
      finally { clearTimeout(timeout); }
    };
    const refresh = link => {
      if (pending.has(link)) return pending.get(link);
      const items = parse(link.dataset.shMtcGenderCandidates) || [];
      const same = items.find(item => item.same_color);
      if (same) {
        link.href = resetUrl(same.url).href;
        return Promise.resolve();
      }
      const request = Promise.all(items.map(availability)).then(states => {
        const item = items.find((candidate, index) => states[index]) || items[0];
        if (item) link.href = resetUrl(item.url).href;
      }).finally(() => pending.delete(link));
      pending.set(link, request);
      return request;
    };
    links.forEach(link => {
      link.href = resetUrl(link.href).href;
      link.addEventListener('focus', () => refresh(link));
      link.addEventListener('pointerenter', () => refresh(link));
      link.addEventListener('click', async event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        await refresh(link);
        link.removeAttribute('aria-busy');
        location.assign(link.href);
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
